module.exports = __webpack_public_path__ + "images/1c54db2b90ee1aff5b25433292b157d0.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/home.png
// module id = 357
// module chunks = 0